module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14K4grl/tc-custom/9781626813816.jpg?1728353457290",
      "alt": "This image is the cover for the book Murder of Ann Avery, The Michael Gray Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder of Ann Avery, The Michael Gray Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A San Francisco psychoanalyst goes searching for a killer when a troubled teen stands falsely accused of murder.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Dr. Michael Gray is constantly getting drawn into the lives, and murders, of his troubled clientele. His keen eye for human behavior leads him to meet some of San Francisco’s most memorable denizens—and to forever be in mortal danger."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When a cinema owner’s wife Ann Avery is murdered, headlines scream for a fast conviction of the juvenile delinquent she had taken under wing. Dr. Gray, however, has other suspects in mind, including a vicious gang leader, a drug addict, a blackmailing drunk, and Ann’s clean-cut husband."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But if the good doctor doesn’t act quickly, someone might get scratched off his list permanently."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("Praise for Henry Kuttner")]), _c('br'), _vm._v(" “A neglected master.” —Ray Bradbury"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Kuttner is magic.” —Joe R. Lansdale\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry Kuttner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0